'use client'
import styles from '@/app/styles/components/pages/cart/delivery-form.module.scss'
import {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import {format} from "date-fns";
import {useDispatch, useSelector} from "react-redux";
import {updateCartData, updateDeliveryCity} from "@/app/slices/CartSlice";
import {dayToString} from "@/app/utils/DateUtil";
import {isLocalDelivery} from "@/app/utils/CartUtil";

const DeliveryForm = () => {

    const [data, setData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        city: '',
        address_1: '',
        postcode: '',
        note: ''
    })
    const [date, setDate] = useState()
    const [time, setTime] = useState()
    const [errors, setErrors] = useState({})

    const [localDelivery, setLocalDelivery] = useState(false);

    const dispatch = useDispatch()
    const cartData = useSelector((state) => state.cart?.data)

    useEffect(() => {
        setLocalDelivery(isLocalDelivery(data?.city))
    }, [data])

    useEffect(() => {
        if(cartData && cartData.deliveryData) {
            setData(cartData.deliveryData)
            setDate(cartData.deliveryData.date)
            setTime(cartData.deliveryData.time)
        }

    }, [])

    useEffect(() => {
        dispatch(updateDeliveryCity(data?.city))
        dispatch(updateCartData({
            deliveryData: {
                ...data,
                time,
                date
            }
        }))

    }, [data, date, time])

    const handleCityOnBlur = () => {
        dispatch(updateDeliveryCity(data?.city))
    }

    const onSubmit = () => {

    }

    const handleDateClick = (date) => {
        setDate(date)
    }

    const handleTimeClick = (time) => {
        setTime(time)
    }

    const handleChangeData = (name, value) => {
        setData({
            ...data,
            [name]: value
        })
    }

    const canPickDateAndTime = () => {
        return data?.city
    }

    const renderDays = () => {

        if(localDelivery) {
            return renderDaysLocal()
        }

        return renderDaysSerbia()
    }

    const renderDaysSerbia = () => {

        let result = []
        const today = new Date();
        const daysInMilliseconds = 24 * 60 * 60 * 1000;

        for(let i = 0; i < 8; i++) {
            const nextDay = new Date(today.getTime() + i * daysInMilliseconds);
            const nextDayString = format(nextDay, 'dd.MM.yyyy')
            const isSameDate = date && nextDayString === date

            if(i === 0 || nextDay.getDay() === 0 || (i === 1 && nextDay.getHours() > 12)) {

                result.push(<div key={'day-' + i} className={styles.dayDisabled} onClick={() => handleDateClick(nextDayString)}>
                    <span>{dayToString(nextDay)}</span>
                    <span>{nextDayString}</span>
                </div>)

                continue
            }

            result.push(<div key={'day-' + i} className={isSameDate ? styles.selectedDay : styles.day} onClick={() => handleDateClick(nextDayString)}>
                <span>{dayToString(nextDay)}</span>
                <span>{nextDayString}</span>
            </div>)
        }

        return result
    }

    const renderDaysLocal = () => {

        let result = []
        const today = new Date();
        const daysInMilliseconds = 24 * 60 * 60 * 1000;

        for(let i = 0; i < 8; i++) {
            const nextDay = new Date(today.getTime() + i * daysInMilliseconds);

            if(i === 0 && nextDay.getHours() > 21) {
                continue
            }

            const nextDayString = format(nextDay, 'dd.MM.yyyy')
            const isSameDate = date && nextDayString === date

            result.push(<div key={'day-' + i} className={isSameDate ? styles.selectedDay : styles.day} onClick={() => handleDateClick(nextDayString)}>
                <span>{dayToString(nextDay)}</span>
                <span>{nextDayString}</span>
            </div>)
        }

        return result
    }

    const renderHours = (date) => {

        if(!date) {
            return ''
        }

        if(!isLocalDelivery(data?.city)) {
            return ''
        }

        const anyTime = <FormattedMessage id={'common.anyTime'}/>

        let result = [
            <div key={'hour-any-time'} className={'Bilo kad' === time ? styles.selectedDay : styles.day} onClick={() => handleTimeClick('Bilo kad')}>
                <span>{anyTime}</span>
            </div>
        ]

        const today = new Date();
        const todayString = format(today, 'dd.MM.yyyy')

        const startHour = todayString === date ? today.getHours() : 8

        for(let i = startHour + 2; i < 22; i++) {
            const hour = `${i}:00`
            const hourHalf = `${i}:30`

            result.push(<div key={'hour-' + i} className={hour === time ? styles.selectedDay : styles.day} onClick={() => handleTimeClick(hour)}>
                <span>{hour}</span>
            </div>)

            result.push(<div key={'hour-half-' + i} className={hourHalf === time ? styles.selectedDay : styles.day} onClick={() => handleTimeClick(hourHalf)}>
                <span>{hourHalf}</span>
            </div>)
        }

        return result
    }

    return <div className={styles.deliveryFormContainer}>
        <h3><FormattedMessage id={'components.pages.cart.deliveryForm.deliveryAddress'}/></h3>
        <form onSubmit={onSubmit}>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.deliveryForm.firstName'}>
                    {
                        (message) =>
                            <input
                                name={'first_name'}
                                type="text"
                                value={data.first_name}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('first_name', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.first_name && <div className={styles.errorMessage}>{errors?.first_name}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.deliveryForm.lastName'}>
                    {
                        (message) =>
                            <input
                                name={'last_name'}
                                type="text"
                                value={data.last_name}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('last_name', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.last_name && <div className={styles.errorMessage}>{errors?.last_name}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.deliveryForm.email'}>
                    {
                        (message) =>
                            <input
                                name={'email'}
                                type="email"
                                value={data.email}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('email', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.email && <div className={styles.errorMessage}>{errors?.email}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.deliveryForm.phone'}>
                    {
                        (message) =>
                            <input
                                name={'phone'}
                                type="text"
                                value={data.phone}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('phone', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.phone && <div className={styles.errorMessage}>{errors?.phone}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.deliveryForm.address'}>
                    {
                        (message) =>
                            <input
                                name={'address_1'}
                                type="text"
                                value={data.address_1}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('address_1', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.address_1 && <div className={styles.errorMessage}>{errors?.address_1}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.deliveryForm.city'}>
                    {
                        (message) =>
                            <input
                                name={'city'}
                                type="text"
                                value={data.city}
                                placeholder={message}
                                autoComplete="off"
                                onBlur={(e) => handleCityOnBlur(e.target.value)}
                                onChange={(e) => handleChangeData('city', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.city && <div className={styles.errorMessage}>{errors?.city}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.deliveryForm.zipCode'}>
                    {
                        (message) =>
                            <input
                                name={'postcode'}
                                type="text"
                                value={data.postcode}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('postcode', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.postcode && <div className={styles.errorMessage}>{errors?.postcode}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.deliveryForm.note'}>
                    {
                        (message) =>
                            <textarea
                                name={'note'}
                                value={data.note}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('note', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.note && <div className={styles.errorMessage}>{errors?.note}</div>}
            </div>

            {
                canPickDateAndTime() &&
                <>
                    <h3><FormattedMessage id={'components.pages.cart.deliveryForm.dateOfDelivery'}/></h3>
                    <div className={styles.daysContainer}>
                        {renderDays()}
                    </div>
                    <h3><FormattedMessage id={'components.pages.cart.deliveryForm.timeOfDelivery'}/></h3>
                    <div className={styles.daysContainer}>
                        {renderHours(date)}
                    </div>

                    {
                        !isLocalDelivery(data?.city) &&
                        <p>
                            <FormattedMessage id={'components.pages.cart.deliveryForm.for'}/> {`${data?.city} ` }
                            <FormattedMessage id={'components.pages.cart.deliveryForm.exactTime'}/>
                        </p>
                    }
                </>
            }
        </form>
    </div>
}

export default DeliveryForm